import { API_PATH_INTERNAL } from '@/lib/constants'
import apiService from '@/lib/services/apiService'
import { UpdateOnboardingChecklistRequest } from '@/types/requests/onboarding-checklists'
import {
  OnboardingChecklistItem,
  UpdateOnboardingChecklistResponse,
} from '@/types/responses/onboarding-checklists'

class OnboardingChecklistService {
  private endpoint = `${API_PATH_INTERNAL}/onboarding-checklists`

  async getChecklist(checklistId: number): Promise<OnboardingChecklistItem> {
    const response = await apiService.get(`${this.endpoint}/${checklistId}`)

    return response.data
  }

  async updateChecklist(
    checklistId: number,
    request: UpdateOnboardingChecklistRequest,
  ): Promise<UpdateOnboardingChecklistResponse> {
    const response = await apiService.patch(
      `${this.endpoint}/${checklistId}`,
      request,
    )

    return response.data
  }

  async completeChecklist(
    checklistId: number,
  ): Promise<UpdateOnboardingChecklistResponse> {
    return this.updateChecklist(checklistId, {
      isComplete: true,
    })
  }
}

const onboardingChecklistService = new OnboardingChecklistService()

export default onboardingChecklistService
